import { Box, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { GridToolbar } from '../../../components/GridToolbar/GridToolbar'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { dataColumn } from '../../../components/DataColumn'
import { Delete } from '@mui/icons-material'
import { useEffect } from 'react'
import { useGetSupplierBankQuery, usePostSupplierMutation } from '../../../store/api/supplierEvaluationApi'
import { useTranslation } from 'react-i18next'
import BankAddDialog from '../BankAccount/BankAddDialog'
export default function IndividualBank({ tableData, setTableData, country }) {

  const { data, isLoading } = useGetSupplierBankQuery(0);
  const [saveMutation] = usePostSupplierMutation();
  const { t } = useTranslation('supplier')

  useEffect(() => {
    if (!isLoading && data?.data?.bankDetails?.length > 0) {
      setTableData(data?.data.bankDetails)
    } else {
      setTableData([])
    }

  }, [data, setTableData, isLoading])


  // Size
  const gridSize = useSelector((state) => state.dataGridSlice.size)

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };


  const columns = [
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <>
            <IconButton onClick={() => handleRowDelete(params.row.id)} sx={{ p: 0, marginLeft: 0.3 }} >
              <Delete sx={{ color: 'red' }} style={{ color: 'red' }} />
            </IconButton>
          </>
        )
      },
    },

    dataColumn('accountNumber', t('bankAccountNumber'), 200, ''),
    dataColumn('currency', t('currency'), 150, ''),
    dataColumn('beneficiary', t('beneficiary'), 200),
  ];

  const [editData, setEditData] = useState([])
  const [doubleClickBool, setDoubleClickBool] = useState(false)

  const handleDoubleClick = (params) => {
    setEditData(params.row)

    handleClickOpen();
    setDoubleClickBool(true)
  }


  const handleClose = () => {
    setOpen(false);

    setDoubleClickBool(false)
    setEditData([])
  };

  const handleRowDelete = (id) => {
    setTableData((prevTableData) =>
      prevTableData.map((row) => {
        if (row.id === id) {
          return { ...row, type: 2 };
        }
        return row;
      })
    );
  }

  return (
    <>
      <Box sx={{ height: 350, width: '100%' }}>
        <DataGrid
          rows={tableData?.filter((row) => row.type === 0)}
          columns={columns}
          getRowId={row => row.id}
          density={gridSize}
          rowHeight={35}
          onRowDoubleClick={handleDoubleClick}
          showCellRightBorder
          components={{
            Toolbar: () => (
              <GridToolbar
                hiddenSearch={false}
                handleAddRow={handleClickOpen}
                hiddenRefresh={true}
              />
            ),
          }}
        />
      </Box>
      <BankAddDialog open={open}
        handleClose={handleClose}
        doubleClickBool={doubleClickBool}
        editData={editData}
        vendorId={0}
        setTableData={setTableData} tableData={tableData}
        currencies={data?.data?.currencies}
        country={country} />
    </>
  )
}

